import type { WebhookDto } from "../../services/ApiService";
import type { Webhook } from "../../types/Webhook";
import WebhookId from "../../state/WebhookId";

export const toWebhook = (dto: WebhookDto): Webhook => ({
  id: WebhookId.from(dto.id),
  name: dto.name,
  url: dto.url,
  enabled: dto.status === "ACTIVE",
  type: dto.type,
  secret: dto.secret,
});
